namespace appn.views.home.index {

    class InitArgs { 
        showSecurityReview: boolean = false;
        handleSecurityViewResult: string = emptyString;
        providerSecurity: string = emptyString;
    }
    
    let _initArgs: InitArgs;
    
    export function init(args: InitArgs) {
        _initArgs = args;
        addEvents();
        
        if (_initArgs.showSecurityReview)
        {
            $('#reviewSecurityDialog').modal('show');
        }
    }

    function addEvents() {
        $('#createform').click(function () {
            appn.iframe.openModal({ url: 'Forms/Create?folderId=' });
        });

        $('#dismissSecureScore, #postponeSecureScore').on('click', function () {
            let elementId = $(this).attr('id');
            appn.ajax.post({
                url: _initArgs.handleSecurityViewResult,
                data:{
                    dismiss: elementId === "dismissSecureScore",
                    postpone: elementId === "postponeSecureScore"
                },
                always: function() {
                    $('#reviewSecurityDialog').modal('hide');
                }
            });
        });
        
        $('#doNotRemind').on('change', function () {
            if($(this).is(':checked')) {
                $('.postpone').hideElement();
                $('.dontRemind').showElement();
            }
            else {
                $('.postpone').showElement();
                $('.dontRemind').hideElement();
            }
        });

        $('#reviewSecureScore').on('click', function () {
            appn.ajax.post({
                url: _initArgs.handleSecurityViewResult,
                data:{
                    dismiss: true
                },
                always: function() {
                    appn.location.navTo(_initArgs.providerSecurity);
                }
            });
        })
    }
}
